import jwtDecode from 'jwt-decode'

export const decodeToken = token => {
  try {
    return jwtDecode(token)
  } catch {
    return null
  }
}

export const validateEmail = email => {
  const expressionRegular =
    /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i
  return expressionRegular.test(email)
}
